<template>
  <div>
    <div
      style="
        display: flex;
        align-items: center;
        margin-top: 50px;
        flex-direction: column;
      "
    >
      <div
        :class="isMobile ? 'col-12' : 'col-8'"
        style="display: flex; align-items: center; justify-content: center"
      >
        <div v-if="!profile_picture" style="text-align: center">
          <media-browser
            filterBy="images"
            v-model="profile_picture"
            :active="showProfileMediaBrowserModal"
            @closeRequest="toggleProfileMediaBrowserModal"
          ></media-browser>
          <i
            @click="toggleProfileMediaBrowserModal"
            style="font-size: 170px"
            class="fa fa-image"
          ></i>
        </div>
        <div
          style="
            display: flex;
            flex-direction: column;
            align-items: center;
            justify-content: center;
          "
          v-else
        >
          <div
            style="
              height: 150px;
              border: solid rgb(140, 198, 63);
              width: 200px;
              border-radius: 15px;
              display: flex;
              align-items: center;
              justify-content: center;
            "
          >
            <img
              :src="
                'data:image/' +
                profile_picture.extension +
                ';base64,' +
                profile_picture.image
              "
              alt=""
            />
          </div>
          <div style="margin-top: 15px">
            <button
              style="
                border-radius: 30px;
                padding-top: 0px;
                padding-left: 7px;
                padding-right: 7px;
                padding-bottom: 0px;
              "
              @click="removeProfilePicture()"
              type="button"
              class="btn btn-danger"
            >
              <i style="font-size: 12px" class="fa fa-trash"></i>
              Remove
            </button>
          </div>
        </div>
      </div>
      <div
        :class="isMobile ? 'col-12' : 'col-8'"
        style="display: flex; margin-top: 25px; padding: 0"
      >
        <div class="col-6">
          <label>Title</label>
          <select class="form-control" v-model="title">
            <option
              v-for="title in titleList"
              :key="title.name"
              :value="title.name"
            >
              {{ title.name }}
            </option>
          </select>
        </div>
        <div class="col-6">
          <label>First Name</label>
          <input
            class="form-control"
            type="text"
            required
            v-model="first_name"
          />
        </div>
      </div>
      <div
        :class="isMobile ? 'col-12' : 'col-8'"
        style="display: flex; margin-top: 15px; padding: 0"
      >
        <div class="col-6">
          <label>Last Name</label>
          <input
            class="form-control"
            type="text"
            required
            v-model="last_name"
          />
        </div>
        <div class="col-6">
          <label>Email</label>
          <input class="form-control" type="text" required v-model="email" />
        </div>
      </div>
      <div
        :class="isMobile ? 'col-12' : 'col-8'"
        style="display: flex; margin-top: 15px; padding: 0"
      >
        <div class="col-6">
          <label>Username</label>
          <div
            style="
              border: 1px solid #ced4da !important;
              border-radius: 5px;
              padding: 5px;
              background-color: lightgray;
            "
          >
            <label style="margin: 0; font-size: 14px">{{ username }}</label>
          </div>
        </div>
        <div class="col-6">
          <label v-if="authUser.force_password_change">New Password*</label>
          <label v-else>Password</label>
          <input
            class="form-control"
            type="password"
            required
            v-model="password"
            placeholder="*************"
          />

          <p v-if="passwordStrength === 'invalid'" style="color: red">
            Invalid (at least 6 characters)
          </p>
          <p v-if="passwordStrength === 'very weak'" style="color: red">
            Very Weak password
          </p>
          <p v-if="passwordStrength === 'weak'" style="color: orange">
            Weak password
          </p>
          <p v-else-if="passwordStrength === 'medium'" style="color: yellow">
            Medium password
          </p>
          <p v-else-if="passwordStrength === 'strong'" style="color: green">
            Strong password
          </p>
        </div>
      </div>
      <div
        :class="isMobile ? 'col-12' : 'col-8'"
        style="display: flex; margin-top: 15px; padding: 0"
      >
        <div class="col-12">
          <label>Confirm Password</label>
          <input
            class="form-control"
            type="password"
            required
            v-model="confirm_password"
            placeholder="*************"
          />
        </div>
      </div>
      <div
        :class="isMobile ? 'col-12' : 'col-8'"
        style="
          display: flex;
          justify-content: end;
          padding-top: 25px;
          padding-bottom: 35px;
        "
      >
        <button type="button" class="btn btn-success" @click="updateUser()">
          Save
        </button>
      </div>
    </div>
  </div>
</template><script>
import sweetAlert from "sweetalert2";
import { mapState } from "vuex";
import UserStorer from "../../storers/StoreUser";
import InvestorStorer from "../../storers/StoreInvestor";
import MediaBrowser from "../common/MediaBrowser.vue";
import { EventBus } from "../../event-bus";
export default {
  name: "profile",
  data() {
    return {
      showProfileMediaBrowserModal: false,
      titleList: [{ name: "Mr." }, { name: "Ms." }],
      isMobile: false,
      title: null,
      first_name: null,
      last_name: null,
      profile_picture: null,
      username: null,
      password: null,
      confirm_password: null,
      email: null,
      passwordStrength: "",
    };
  },
  components: {
    MediaBrowser,
  },
  created: function () {
    this.fillForm();
    let self = this;
    EventBus.$on("changeTab", function (tab) {
      if (tab == "dashboard") {
        self.$router.push("/" + self.authUser.userable_type + "/dashboard");
      }
    });
  },
  computed: {
    ...mapState({
      authUser: (state) => state.userStore.authUser,
      updateUserStatus: (state) => state.userStore.userUpdate.updateUserStatus,
      updateUserMessage: (state) =>
        state.userStore.userUpdate.updateUserMessage,
    }),
  },
  mounted() {
    window.addEventListener("resize", this.onResize);
    this.onResize();
  },
  methods: {
    checkIsMobile() {
      return window.innerWidth < 768;
    },
    onResize() {
      this.isMobile = this.checkIsMobile();
    },
    fillForm() {
      this.title = this.authUser.userable.title;
      this.first_name = this.authUser.userable.first_name;
      this.last_name = this.authUser.userable.last_name;
      this.username = this.authUser.username;
      this.email = this.authUser.email;
      this.profile_picture = this.authUser.profile_picture;
    },
    checkPasswordStrength() {
      const weakPasswordRegex =
        /^(?=.{6,})(?=.*[a-z])(?=.*[A-Z d])(?=.*[^a-zA-Z\d])/;
      const mediumPasswordRegex =
        /^(?=.{8,})(?=.*[a-z])(?=.*[A-Z])(?=.*[\d])(?=.*[^a-zA-Z\d])(?=.*[!$#%&()*+,-./:;<=>?@[\]^_`{|}~])/;
      const strongPasswordRegex =
        /^(?=.{10,})(?=.*[a-z])(?=.*[A-Z])(?=.*[\d])(?=.*[^a-zA-Z\d])(?=.*[!$#%&()*+,-./:;<=>?@[\]^_`{|}~])/;
      const veryWeakPasswordRegex =
        /^(?=.{6,})[a-z]*|[A-Z]*|[0-9]*|[^a-zA-Z0-9]*$/;

      if (strongPasswordRegex.test(this.password)) {
        this.passwordStrength = "strong";
      } else if (
        mediumPasswordRegex.test(this.password) ||
        this.password.length > 12
      ) {
        this.passwordStrength = "medium";
      } else if (
        weakPasswordRegex.test(this.password) ||
        this.password.length > 10
      ) {
        this.passwordStrength = "weak";
      } else if (veryWeakPasswordRegex.test(this.password)) {
        this.passwordStrength = "very weak";
      } else if (this.password.length < 6) {
        this.passwordStrength = "invalid"; // Doesn't meet any defined criteria
      } else {
        this.passwordStrength = "";
      }
      // if (regexStrong.test(this.password)) {
      //   this.passwordStrength = "strong";
      // } else if (regexMedium.test(this.password)) {
      //   this.passwordStrength = "medium";
      // } else if (regexWeak.test(this.password)) {
      //   this.passwordStrength = "weak";
      // } else if (veryWeakPasswordRegex.test(this.password)) {
      //   this.passwordStrength = "very weak";
      // } else if (this.password.length < 6) {
      //   this.passwordStrength = "invalid";
      // } else {
      //   this.passwordStrength = "";
      // }
    },
    removeProfilePicture() {
      this.profile_picture = null;
    },
    formValidation() {
      const result = { isValid: true, message: "" };
      result.message += "Please fill all required fields";
      let missingFieldsString = "";
      if (this.username.length < 5) {
        missingFieldsString += "Username is less than 5 characters ,";
        result.isValid = false;
      }
      if (this.title != "Mr." && this.title != "Ms.") {
        missingFieldsString += "Title prefix is missing, ";
        result.isValid = false;
      }
      if (this.first_name.length < 2) {
        missingFieldsString += "First name is less than 3 characters, ";
        result.isValid = false;
      }
      if (this.last_name.length < 2) {
        missingFieldsString += "Last name is less than 3 characters, ";
        result.isValid = false;
      }
      if (!this.email.trim()) {
        missingFieldsString += "Email, ";
        result.isValid = false;
      }
      if (!this.password && this.authUser.force_password_change) {
        missingFieldsString += "New password is required, ";
        result.isValid = false;
      }
      if (
        this.password &&
        (this.passwordStrength == "weak" ||
          this.passwordStrength == "very weak" ||
          this.passwordStrength == "invalid")
      ) {
        missingFieldsString += "Password needs improvment, ";
        result.isValid = false;
      }
      if (this.password && this.password.length < 5) {
        missingFieldsString += "Password is less than 5 characters, ";
        result.isValid = false;
      }
      if (this.password != this.confirm_password) {
        missingFieldsString +=
          "Password and Confirmation password are not equal, ";
        result.isValid = false;
      }
      if (missingFieldsString.length > 0) {
        // remove trailing comma
        missingFieldsString = missingFieldsString.substring(
          0,
          missingFieldsString.length - 2
        );
        result.message += ` (${missingFieldsString})`;
      }
      return result;
    },
    updateUser() {
      const { isValid, message } = this.formValidation();
      if (!isValid) {
        sweetAlert({
          title: "Error",
          text: message,
          type: "error",
          confirmButtonText: "Return",
        });
        return;
      }

      var userStorer = UserStorer();
      var investorStorer = InvestorStorer();

      userStorer.id = this.authUser.id;
      userStorer.username = this.username;
      userStorer.email = this.email;
      userStorer.password = this.password;
      userStorer.userable_type = this.authUser.userable_type;
      userStorer.userable_id = this.authUser.userable_id;

      investorStorer.id = this.authUser.userable.id;
      investorStorer.code = this.authUser.userable.code;
      investorStorer.title = this.title;
      investorStorer.first_name = this.first_name;
      investorStorer.last_name = this.last_name;
      investorStorer.home_address = this.authUser.userable.home_address;
      investorStorer.mailing_address = this.authUser.userable.mailing_address;
      investorStorer.mobile_number = this.authUser.userable.mobile_number;
      investorStorer.date_of_birth = this.authUser.userable.date_of_birth;
      investorStorer.gender = this.authUser.userable.gender;
      investorStorer.marital_status = this.authUser.userable.marital_status;
      investorStorer.emergency_contact_name =
        this.authUser.userable.emergency_contact_name;
      investorStorer.emergency_contact_number =
        this.authUser.userable.emergency_contact_number;
      investorStorer.emergency_contact_relation =
        this.authUser.userable.emergency_contact_relation;
      investorStorer.emergency_contact_email =
        this.authUser.userable.emergency_contact_email;
      investorStorer.enabled = this.authUser.userable.enabled;
      investorStorer.nationality_id = this.authUser.userable.nationality_id;
      investorStorer.country_of_residence_id =
        this.authUser.userable.country_of_residence_id;
      investorStorer.pasport_id = this.authUser.userable.pasport_id;
      investorStorer.passport_image_id =
        this.authUser.userable.passport_image_id;
      if (this.authUser.userable.profile_picture) {
        investorStorer.profile_picture_id =
          this.authUser.userable.profile_picture.id;
      }

      userStorer.userable = investorStorer;

      this.$store.dispatch("updateUser", {
        userStorer: userStorer,
        is_user_profile: true,
      });
    },
    toggleProfileMediaBrowserModal() {
      this.showProfileMediaBrowserModal = !this.showProfileMediaBrowserModal;
    },
  },
  beforeDestroy() {
    window.removeEventListener("resize", this.onResize);
  },
  watch: {
    password() {
      if (!this.password) {
        this.passwordStrength = "";
      } else {
        this.checkPasswordStrength();
      }
    },
    updateUserStatus() {
      if (this.updateUserStatus == "success") {
        sweetAlert({
          title: "Success",
          text: "User has been updated successfully",
          icon: "success",
          confirmButtonText: "Done",
        }).then(() => {
          this.$router.push("/" + this.authUser.userable_type + "/dashboard");
        });
      } else if (this.updateUserStatus == "failed") {
        var message = "";
        if (this.updateUserMessage == "A new password is required") {
          message = "Please use a new password";
        }
        sweetAlert({
          title: "Failed",
          text: "User update has failed, " + message,
          IntersectionObserver: "error",
          confirmButtonText: "Return",
        });
      }
    },
  },
};
</script> 
 <style>
.md-ripple {
  padding: 0px !important;
}
.table.vgt-table {
  font-size: 20px;
}
.form-control {
  border: 1px solid #ced4da !important;
  background-image: none;
  border-radius: 5px !important;
  padding: 10px;
}
</style>


// WEBPACK FOOTER //
// resources/js/pages/investor/profile.vue